export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ManageVisitsResults.vue?vue&type=template&id=01265c4c&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/CommercialManagement/ManageVisitsResults.vue?vue&type=template&id=01265c4c&scoped=true&
// module id = null
// module chunks = 